const States = [
    {
      state: "Kerala",
      charge: 0
    }
  ];
export default States;